import { MANUAL_PROMOTION_WEEKLY_POST_CAP } from "../components/campaign/types";

// The weekly slots a platform's wizard schedule produces: days x posts per
// day, or every day for Daily. Same quantity the api counts.
export const promotionWeeklySlots = (
    frequency: "Daily" | "Weekly",
    dayOfWeek: string[] | undefined,
    postsPerDay: number,
): number => {
    // Edit mode prefills the platform straight from the stored campaign, so
    // these can arrive malformed; one post a day is the floor either way.
    const perDay = Number.isFinite(postsPerDay) ? postsPerDay : 1;
    if (frequency === "Daily") return 7 * perDay;
    const days = Array.isArray(dayOfWeek) ? dayOfWeek.length : 0;
    return days * perDay;
};

export interface PromotionWeeklyCapResult {
    allowed: boolean;
    slots: number;
    cap: number;
}

// Null for a channel the cap does not cover, so callers can gate only where
// a limit exists.
export const checkPromotionWeeklyCap = (
    platformName: string,
    frequency: "Daily" | "Weekly",
    dayOfWeek: string[] | undefined,
    postsPerDay: number,
): PromotionWeeklyCapResult | null => {
    const cap = MANUAL_PROMOTION_WEEKLY_POST_CAP[platformName];
    if (cap === undefined) return null;
    const slots = promotionWeeklySlots(frequency, dayOfWeek, postsPerDay);
    return { allowed: slots <= cap, slots, cap };
};

export const PROMOTION_WEEKLY_CAP_MESSAGE =
    "Neighborhood Expert posts are limited to 2 per week per channel.";
